<template>
  <v-card :loading="loading" class="mx-auto my-12" max-width="474"  min-height="550">
    <v-img height="250" :src="image"></v-img>

    <v-card-title>Visite-nos FaceBook</v-card-title>

    <v-card-text>
<!--
      <v-row align="center" class="mx-0">
        <v-rating
          :value="4.5"
          color="amber"
          dense
          half-increments
          readonly
          size="14"
        ></v-rating>

        <div class="grey--text ml-4">4.5 (413)</div>
      </v-row>

                <div class="my-4 subtitle-1 black--text">
                  * • Facebook, Noticias
                </div>
-->

      <div>
        O
        <span style="font-family: 'Fontdiner Swanky', serif;"
          >VIOLENT NOISE</span
        >
        esta no Facebook, trazendo todas as noticias das bandas do Brasil e do
        mundo.
      </div>
    </v-card-text>

    <v-divider class="mx-4"></v-divider>

    <!--
              <v-card-title>Veja as noticias</v-card-title>
-->

    <v-card-actions>
      <v-btn color="deep-purple accent-4" text @click="showFacebook">
        Acompanhe as noticias
      </v-btn>
    </v-card-actions>

    <v-card-actions>
      <iframe
        :src="facebooklink"
        width="157"
        height="65"
        style="border:none;overflow:hidden"
        scrolling="no"
        frameborder="0"
        allowTransparency="true"
        allow="encrypted-media"
      ></iframe>
    </v-card-actions>
  </v-card>
</template>

<script>
const image2 = require("@/assets/images/content/drums.jpg");

export default {
  data: () => ({
    image: image2,
    loading: false,
    facebooklink: "https://www.facebook.com/plugins/like.php?href=https%3A%2F%2Fwww.facebook.com.br%2Fviolent-noise-blog&width=157&layout=button&action=like&size=small&share=true&height=65&appId",
  }),
  created: function() {

  },
  methods: {
    showFacebook: function() {
      this.$store.commit("setIsFacebook", true);
    }
  }
};
</script>

<style></style>
